import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../contexts/user";
import { AssessmentContext } from "../../contexts/assessments";
import { getisCompletedAssessment, getCompleteDate } from "../../axios/axiosFunctions";
import { Box, Button, CircularProgress, Container, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import bgImage from '../../assets/images/bgImage.png';
import WelcomeIntro from "../../components/WelcomeIntro";
import TIMTeams from "../../components/TIMTeams";
import { GroupContext } from "../../contexts/group";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SELF_SLUG_MAP = {
    "lim_360_assessment": "lim_self_assessment",
    "mim_360_assessment": "mim_self_assessment",
};

const WelcomeAssessment = () => {

    const navigate = useNavigate();
    const {slugAssessment}=useParams();
    const {currentUser} = useContext(UserContext);
    const {currentGroup,setCurrentGroup,setLevel} = useContext(GroupContext);
    const {getAssessmentBySlug,isLoading} = useContext(AssessmentContext);
    const [currentAssessment, setCurrentAssessment] = useState();
    const [currentBlocks, setCurrentBlocks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lastCompleted, setLastCompleted] = useState({slug:"",pos:0});
    const [openPreFillDialog, setOpenPreFillDialog] = useState(false);
    const [selfCompletionDate, setSelfCompletionDate] = useState("");

    useEffect(() => {
        if(!isLoading){
            const assessment = getAssessmentBySlug(slugAssessment);
            if(!assessment){
                navigate('/');
                return;
            }
            setCurrentAssessment(assessment);
            if(assessment.is360){
                setCurrentBlocks(assessment.ownerBlocks);
            }else{
                setCurrentBlocks(assessment.blocks);
            }
        }
    }, [slugAssessment,isLoading,getAssessmentBySlug,navigate]);

    useEffect(() => {
        if(currentAssessment){
            const checkIfComplete = async()=>{
                const isComplete = await getisCompletedAssessment(currentAssessment._id,currentUser._id);
                if(isComplete.valid){
                    if(slugAssessment === "mim_360_assessment" || slugAssessment === "lim_360_assessment"){
                        navigate(`/`);
                    }else{
                        navigate(`/${slugAssessment}/complete`);
                    }

                }
                setLastCompleted(isComplete.slug);
                setLoading(false);

                // Check if this is a 360 and user has completed the corresponding self-assessment
                const selfSlug = SELF_SLUG_MAP[slugAssessment];
                if (selfSlug && !isComplete.valid) {
                    const sessionKey = `prefill_shown_${slugAssessment}_${currentUser._id}`;
                    const alreadyShown = sessionStorage.getItem(sessionKey);
                    if (!alreadyShown) {
                        try {
                            const dateRes = await getCompleteDate(currentUser._id, selfSlug);
                            if (dateRes?.dateCompleted) {
                                setSelfCompletionDate(dateRes.dateCompleted);
                                setOpenPreFillDialog(true);
                                sessionStorage.setItem(sessionKey, "true");
                            }
                        } catch (err) {
                            console.log("Error checking self-assessment completion:", err);
                        }
                    }
                }
            }
            checkIfComplete();
        }
    }, [isLoading,currentAssessment,currentUser,navigate,slugAssessment]);

    const handleGoBack = ()=>{
        setLevel(0);
        setCurrentGroup(undefined);
        localStorage.setItem("groupLL",JSON.stringify({group:undefined,level:0}));
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr + "T00:00:00");
        return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    };

    return (
    <Container maxWidth="false" sx={{padding:"0px !important",backgroundColor:"#fff"}}>
        {
            loading &&
            <Box sx={{padding:"48px"}}>
                <CircularProgress/>
            </Box>
        }
        {
            !loading &&
            <Box display="flex" flexDirection="column">
                {
                    isLoading && <Box sx={{padding:"48px"}}><CircularProgress/></Box>
                }
                {
                    !isLoading && <>
                        <Box sx={{backgroundColor:"#e8f4f8",padding:"48px 48px 40px"}}>
                            {
                                currentGroup &&
                                <Box display={"flex"} alignItems={"center"} sx={{marginBottom:"8px"}}>
                                    <IconButton onClick={handleGoBack}>
                                        <ArrowBackIcon color="secondary"/>
                                        <Typography variant="subtitle2" color="secondary">Go back</Typography>
                                    </IconButton>
                                </Box>
                            }
                            <Typography variant='h4' color='primary' fontWeight={600}>WELCOME {currentGroup? currentGroup.name:""}</Typography>
                            {
                                slugAssessment === "tim_self_assessment" ?
                                <>
                                    <TIMTeams currentAssessment={currentAssessment} blockLength={currentAssessment?.blocks.length}/>
                                </>
                                :
                                <>
                                    <WelcomeIntro introText={currentAssessment?.introText} mainImage={currentAssessment?.mainImage} slug={lastCompleted}/>
                                </>
                            }
                        </Box>
                    </>
                }
            </Box>
        }

        {/* Pre-fill notification dialog for 360 assessments */}
        <Dialog open={openPreFillDialog} onClose={() => setOpenPreFillDialog(false)} maxWidth="sm" fullWidth>
            <DialogContent sx={{ padding: "32px" }}>
                <Typography variant="h6" color="primary" sx={{ textAlign: "center", marginBottom: "16px", fontWeight: 600 }}>
                    Self-Assessment Previously Completed
                </Typography>
                <Typography variant="body1" color="secondary" sx={{ textAlign: "center", lineHeight: 1.7 }}>
                    You completed the self-assessment on <strong>{formatDate(selfCompletionDate)}</strong>. Your responses have been pre-filled with your previous results for review.
                </Typography>
                <Typography variant="body1" color="secondary" sx={{ textAlign: "center", lineHeight: 1.7, marginTop: "12px" }}>
                    Please review each section and update your answers based on your current experience before submitting.
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                    <Button onClick={() => setOpenPreFillDialog(false)} variant="contained" color="primary">
                        GOT IT
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    </Container>
    )
}

export default WelcomeAssessment
